import { render, staticRenderFns } from "./AllSalaryReportsIndex.vue?vue&type=template&id=617b4f92&scoped=true"
import script from "./AllSalaryReportsIndex.vue?vue&type=script&lang=js"
export * from "./AllSalaryReportsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b4f92",
  null
  
)

export default component.exports